import Weather from '../assets/projects/4.png'
import Quiz from '../assets/projects/2.png'
import Music from '../assets/projects/3.png'
import Exercise from '../assets/projects/1.png'

export const data=[
    {
        id:1,
        name:"Weather Application",
        image:Weather,
        github:"https://github.com/Olamaryse/Weather-Forecast.git",
        live:"https://not-your-regular-forecast.pages.dev/",
    },
    {
        id:2,
        name:"Quiz Application",
        image:Quiz,
        github:"https://github.com/Olamaryse/appquiz.git",
        live:"https://appquiz.pages.dev/",
    },
    {
        id:3,
        name:"Music Application",
        image:Music,
        github:"https://github.com/Kaystringscode/MOODLY.git",
        live:"https://lucky-tulumba-fcee3b.netlify.app/",
    },
    {
        id:4,
        name:"Exercise Application",
        image:Exercise,
        github:"https://github.com/Olamaryse/exercise-app.git",
        live:"https://exercise-app.pages.dev/",
    },


]